import { capitalize } from "lodash";

export const formatDate = (date: string): string => new Date(date).toLocaleString();

export const formatStatus = (status: string) => capitalize(status);
